import React, { useEffect, useState } from "react";
import { ReactNode } from "react";

interface IProps {
   children: ReactNode
}

export const RenderTabOnFocus: React.FC<IProps> = (props: IProps) => {
   const [hasFocus, setHasFocus] = useState<boolean>(false);

   if (!hasFocus) {

      window.addEventListener('focus', function (e) {

         setHasFocus(true);
      }, { once: true });
   }

   return (
      <div key={hasFocus.toString()}>
         {props.children}
      </div>
   );
}